import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  departments: [],
  selectedDepartment: null,
};

const departmentSlice = createSlice({
  name: "companyDepartment",
  initialState,
  reducers: {
    // Get Departments
    getDepartmentsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getDepartmentsSuccess: (state, action) => {
      state.loading = false;
      state.departments = action.payload;
      state.error = null;
    },
    getDepartmentsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Department
    createDepartmentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createDepartmentSuccess: (state, action) => {
      state.loading = false;
      state.departments.push(action.payload);
      state.error = null;
    },
    createDepartmentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Update Status
    updateDepartmentStatusStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateDepartmentStatusSuccess: (state, action) => {
      state.loading = false;
      const index = state.departments.findIndex(
        (dept) => dept.id === action.payload.id,
      );
      if (index !== -1) {
        state.departments[index].status = action.payload.status;
      }
      state.error = null;
    },
    updateDepartmentStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Update Department
    updateDepartmentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateDepartmentSuccess: (state, action) => {
      state.loading = false;
      const index = state.departments.findIndex(
        (dept) => dept.id === action.payload.id,
      );
      if (index !== -1) {
        state.departments[index] = action.payload;
      }
      state.error = null;
    },
    updateDepartmentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Department
    setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getDepartmentsStart,
  getDepartmentsSuccess,
  getDepartmentsFailure,
  createDepartmentStart,
  createDepartmentSuccess,
  createDepartmentFailure,
  updateDepartmentStart,
  updateDepartmentSuccess,
  updateDepartmentFailure,
  updateDepartmentStatusStart,
  updateDepartmentStatusSuccess,
  updateDepartmentStatusFailure,
  setSelectedDepartment,
  clearError,
} = departmentSlice.actions;

export default departmentSlice.reducer;
